import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StepperTextDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 1,
        minWidth: 0
    },
    title: {
        flexShrink: 1
    }
});

export const useStyles = ({
    measures,
    spaces
}: StepperTextDynamicStyleType) => {
    const styles = {
        container: {
            paddingTop: (measures.markerSize - measures.lineHeight) / 2,
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
